import React from 'react';
import { Input, Header, Message } from 'semantic-ui-react'

// import './forms_inputs_text.css';

const FormsInputsNumber = ({field, form: {touched, errors}, ...props}) => {
    const hasError = (errors[field.name] && touched[field.name]) ? true : false;
    return (
        <div className="field">
            <>
                <Header as='h5'>{props.label}</Header>
                {(props.secondaryLabel) ? <Header.Subheader>{props.secondaryLabel}</Header.Subheader>: ''}
            </>
            <Input type='number' fluid {...field} disabled={(props.disabled) ? props.disabled : false} />
            {
                hasError &&
                (
                    <Message negative>
                        {errors[field.name]}
                    </Message>
                )
            }
        </div>
    );
}

export default FormsInputsNumber;
